<template>
  <!-- Monument component displays instead of map/list on main Explore page -->
  <div id="monument-container">
    <div id="monument-menu-container">
      <div id="monument-menu">
        <div
          id="monument-menu-description"
          class="monument-menu-item"
          :class="{ selected: view.description }"
          @click="changeView($event)"
          v-if="
            !lessThan899 ||
            (lessThan899 && view.description) ||
            (lessThan899 && showTabDropdowns)
          "
        >
          DESCRIPTION
          <font-awesome-icon
            :icon="['fas', 'chevron-down']"
            class="monument-menu-arrow"
            v-if="lessThan899 && !showTabDropdowns && view.description"
          />
          <font-awesome-icon
            :icon="['fas', 'chevron-up']"
            class="monument-menu-arrow"
            v-else-if="lessThan899 && showTabDropdowns && view.description"
          />
        </div>
        <div
          id="monument-menu-map"
          class="monument-menu-item"
          :class="{ selected: view.map }"
          @click="changeView($event)"
          v-if="
            !lessThan899 ||
            (lessThan899 && view.map) ||
            (lessThan899 && showTabDropdowns)
          "
        >
          MAP
          <font-awesome-icon
            :icon="['fas', 'chevron-down']"
            class="monument-menu-arrow"
            v-if="lessThan899 && !showTabDropdowns && view.map"
          />
          <font-awesome-icon
            :icon="['fas', 'chevron-up']"
            class="monument-menu-arrow"
            v-else-if="lessThan899 && showTabDropdowns && view.map"
          />
        </div>
        <div
          id="monument-menu-directions"
          class="monument-menu-item"
          :class="{ selected: view.directions }"
          @click="changeView($event)"
          v-if="
            (!lessThan899 && (monument &&
              monument.monumentDetails &&
              getDirectionsInfoExists(monument.monumentDetails[0].details))) ||
            (monument &&
              monument.monumentDetails &&
              getDirectionsInfoExists(monument.monumentDetails[0].details) &&
            ((lessThan899 && view.directions) ||
            (lessThan899 && showTabDropdowns)))
          "
        >
          GET DIRECTIONS
          <font-awesome-icon
            :icon="['fas', 'chevron-down']"
            class="monument-menu-arrow"
            v-if="lessThan899 && !showTabDropdowns && view.directions"
          />
          <font-awesome-icon
            :icon="['fas', 'chevron-up']"
            class="monument-menu-arrow"
            v-else-if="lessThan899 && showTabDropdowns && view.directions"
          />
        </div>
        <div
          id="monument-menu-additional"
          class="monument-menu-item"
          :class="{ selected: view.additional }"
          @click="changeView($event)"
          v-if="
            (!lessThan899 && (monument &&
              monument.monumentDetails &&
              additionalInfoExists())) ||
            (monument &&
              monument.monumentDetails &&
              additionalInfoExists() &&
              ((lessThan899 && view.additional) ||
                (lessThan899 && showTabDropdowns)))
          "
        >
          ADDITIONAL INFORMATION
          <font-awesome-icon
            :icon="['fas', 'chevron-down']"
            class="monument-menu-arrow"
            v-if="lessThan899 && !showTabDropdowns && view.additional"
          />
          <font-awesome-icon
            :icon="['fas', 'chevron-up']"
            class="monument-menu-arrow"
            v-else-if="lessThan899 && showTabDropdowns && view.additional"
          />
        </div>
        <div
          id="monument-menu-content"
          class="monument-menu-item"
          :class="{ selected: view.content }"
          @click="changeView($event)"
          v-if="
            hasInfo(monument.relatedContent) &&
            (!lessThan899 ||
              (lessThan899 && view.content) ||
              (lessThan899 && showTabDropdowns))
          "
        >
          RELATED CONTENT
          <font-awesome-icon
            :icon="['fas', 'chevron-down']"
            class="monument-menu-arrow"
            v-if="lessThan899 && !showTabDropdowns && view.content"
          />
          <font-awesome-icon
            :icon="['fas', 'chevron-up']"
            class="monument-menu-arrow"
            v-else-if="lessThan899 && showTabDropdowns && view.content"
          />
        </div>
        <div
          id="monument-menu-itineraries"
          class="monument-menu-item"
          :class="{ selected: view.itineraries }"
          @click="changeView($event)"
          v-if="
            hasInfo(monument.relatedItineraries) &&
            (!lessThan899 ||
              (lessThan899 && view.itineraries) ||
              (lessThan899 && showTabDropdowns))
          "
        >
          RELATED ITINERARIES
          <font-awesome-icon
            :icon="['fas', 'chevron-down']"
            class="monument-menu-arrow"
            v-if="lessThan899 && !showTabDropdowns && view.itineraries"
          />
          <font-awesome-icon
            :icon="['fas', 'chevron-up']"
            class="monument-menu-arrow"
            v-else-if="lessThan899 && showTabDropdowns && view.itineraries"
          />
        </div>
      </div>
    </div>

    <div id="explore-map" ref="exploreMap" v-show="view.map"></div>

    <div id="monument-descriptions-container" v-if="view.description">
      <div
        v-for="(entry, index) in monument.monumentDetails"
        :key="`entry-${index}`"
      >
        <div
          class="monument-description-header"
          @click="descriptionIndex = index"
        >
          <div v-html="entry.details[language(entry.details)].name"></div>
          <div class="monument-source-project">
            In
            <span>{{
              entry.details[language(entry.details)].projectName
            }}</span>
            {{ entry.from[language(entry.from)].value }}
          </div>
        </div>
        <div class="description-wrapper" v-if="descriptionIndex === index">
          <MonumentDescription
            :entry="entry"
            :language="defaultLanguage"
            :location="monument.locationName"
            :country="monument.countryName"
            :glossary="monument.glossary"
          >
          </MonumentDescription>
        </div>
      </div>
    </div>

    <div id="monument-directions" v-if="view.directions && monument.monumentDetails">
      <div class="monument-language-selection" v-if="languagesList.length > 1">
        <label>Read in </label>
        <select v-model="defaultLanguage">
          <option v-for="language in languagesList" :key="language">
            {{ language }}
          </option>
        </select>
      </div>
      <MonumentField
        :language="defaultLanguage"
        :details="monument.monumentDetails[0].details"
        :field="'getDirections'"
        :label="'Directions'"
      >
      </MonumentField>
      <MonumentField
        :language="defaultLanguage"
        :details="monument.monumentDetails[0].details"
        :field="'address'"
        :label="'Address'"
      >
      </MonumentField>
      <MonumentField
        :language="defaultLanguage"
        :details="monument.monumentDetails[0].details"
        :field="'contact'"
        :label="'Contact'"
      >
      </MonumentField>
      <MonumentField
        :language="defaultLanguage"
        :details="monument.monumentDetails[0].details"
        :field="'tel'"
        :label="'Telephone'"
      >
      </MonumentField>
      <MonumentField
        :language="defaultLanguage"
        :details="monument.monumentDetails[0].details"
        :field="'fax'"
        :label="'Fax'"
      >
      </MonumentField>
      <MonumentField
        :language="defaultLanguage"
        :details="monument.monumentDetails[0].details"
        :field="'email'"
        :label="'Email'"
      >
      </MonumentField>
      <MonumentField
        :language="defaultLanguage"
        :details="monument.monumentDetails[0].details"
        :field="'website'"
        :label="'Website'"
      >
      </MonumentField>
      <MonumentField
        :language="defaultLanguage"
        :details="monument.monumentDetails[0].details"
        :field="'responsibleInstitution'"
        :label="'Responsible Institution'"
      >
      </MonumentField>
    </div>

    <div id="monument-additional" v-if="view.additional && monument.monumentDetails">
      <div class="monument-language-selection" v-if="languagesList.length > 1">
        <label>Read in </label>
        <select v-model="defaultLanguage">
          <option v-for="language in languagesList" :key="language">
            {{ language }}
          </option>
        </select>
      </div>
      <MonumentField
        :language="defaultLanguage"
        :details="monument.monumentDetails[0].details"
        :field="'information'"
        :label="'Information'"
      >
      </MonumentField>
      <MonumentField
        :language="defaultLanguage"
        :details="monument.monumentDetails[0].details"
        :field="'note'"
        :label="'Notes'"
      >
      </MonumentField>
      <MonumentField
        :language="defaultLanguage"
        :details="monument.monumentDetails[0].details"
        :field="'styles'"
        :label="'Styles'"
      >
      </MonumentField>
      <MonumentField
        :language="defaultLanguage"
        :details="monument.monumentDetails[0].details"
        :field="'bibliography'"
        :label="'Bibliography'"
      >
      </MonumentField>

      <div
        class="monument-language-selection"
        v-if="furtherReadingsLanguagesList.length > 1"
      >
        <label>Read in </label>
        <select v-model="furtherReadingsLanguage">
          <option
            v-for="language in furtherReadingsLanguagesList"
            :key="language"
          >
            {{ language }}
          </option>
        </select>
      </div>
      <div
        class="further-readings-container"
        v-if="
          monument.monumentDetails[0].furtherReadings &&
          monument.monumentDetails[0].furtherReadings.length > 0
        "
      >
        <div class="further-readings-label">Further Readings</div>
        <div
          class="further-readings"
          v-for="reading in furtherReading.readings"
          :key="reading.url"
        >
          <a
            :href="reading.url"
            target="_blank"
            v-html="reading.text.length > 0 ? reading.text : reading.url">
          </a>
          <span v-if="reading.fileDetails.length > 0">
            ({{ reading.fileDetails }})</span
          >
          <div v-if="reading.abstract.length > 0" v-html="reading.abstract">
          </div>
        </div>
      </div>

      <div
        class="monument-language-selection"
        v-if="locationLanguagesList.length > 1"
      >
        <label>Read in </label>
        <select v-model="locationLanguage">
          <option v-for="language in locationLanguagesList" :key="language">
            {{ language }}
          </option>
        </select>
      </div>
      <div class="location-contact" v-if="monument.locationContact.length > 0">
        Other Contact:
        <MonumentField
          :language="locationLanguage"
          :details="monument.locationContact"
          :field="'institution'"
          :label="'Institution'"
        >
        </MonumentField>
        <MonumentField
          :language="locationLanguage"
          :details="monument.locationContact"
          :field="'street'"
          :label="'Street'"
        >
        </MonumentField>
        <MonumentField
          :language="locationLanguage"
          :details="monument.locationContact"
          :field="'zip'"
          :label="'Zip'"
        >
        </MonumentField>
        <MonumentField
          :language="locationLanguage"
          :details="monument.locationContact"
          :field="'city'"
          :label="'City'"
        >
        </MonumentField>
        <MonumentField
          :language="locationLanguage"
          :details="monument.locationContact"
          :field="'phone'"
          :label="'Phone'"
        >
        </MonumentField>
        <MonumentField
          :language="locationLanguage"
          :details="monument.locationContact"
          :field="'fax'"
          :label="'Fax'"
        >
        </MonumentField>
        <MonumentField
          :language="locationLanguage"
          :details="monument.locationContact"
          :field="'email'"
          :label="'Email'"
        >
        </MonumentField>
        <MonumentField
          :language="locationLanguage"
          :details="monument.locationContact"
          :field="'url'"
          :label="'URL'"
        >
        </MonumentField>
        <MonumentField
          :language="locationLanguage"
          :details="monument.locationContact"
          :field="'note'"
          :label="'Note'"
        >
        </MonumentField>
      </div>

      <div
        class="monument-additional"
        v-if="monument.accommodations.length > 0"
      >
        <div class="additional-label">
          <div>ACCOMMODATIONS</div>
        </div>
        <div
          class="accommodations-wrapper"
          v-for="accommodation in monument.accommodations"
          :key="accommodation.title"
        >
          <div
            class="accommodations-hotel"
            v-for="hotel in accommodation.hotels"
            :key="hotel.details.name"
          >
            <div v-html="hotel.details.name"></div>
            <div class="hotel-category" v-html="hotel.category"></div>
            <div v-html="hotel.details.street"></div>
            <div v-html="hotel.details.city"></div>
            <div v-html="hotel.details.zip"></div>
            <div v-html="hotel.details.phone"></div>
            <div v-html="hotel.details.fax"></div>
            <div v-html="hotel.details.email"></div>
            <div class="hotel-url">
              <a :href="hotel.details.url" target="_blank">
                {{ hotel.details.url }}
              </a>
            </div>
            <div v-html="hotel.details.note"></div>
          </div>
        </div>
      </div>
      <div class="monument-additional" v-if="monument.guidedVisits.length > 0">
        <div class="additional-label">
          <div>GUIDED VISITS</div>
        </div>
        <div
          class="guided-visits-wrapper"
          v-for="visit in monument.guidedVisits"
          :key="visit.id"
        >
          <div class="guided-visits-contact">
            <div v-html="visit.contact.name"></div>
            <div v-html="visit.contact.street"></div>
            <div v-html="visit.contact.city"></div>
            <div v-html="visit.contact.zip"></div>
            <div v-html="visit.contact.phone"></div>
            <div v-html="visit.contact.fax"></div>
            <div v-html="visit.contact.email"></div>
            <div class="guided-visit-url">
              <a :href="visit.contact.url" target="_blank">
                {{ visit.contact.url }}
              </a>
            </div>
            <div v-html="visit.contact.contactPerson"></div>
            <div v-html="visit.contact.note"></div>
          </div>
        </div>
      </div>
      <div
        class="monument-additional"
        v-if="monument.usefulWebsites.length > 0"
      >
        <div class="additional-label">USEFUL WEBSITES</div>
        <div
          class="useful-websites-site"
          v-for="site in monument.usefulWebsites"
          :key="site.title"
        >
          <div>{{ site.title }}</div>
          <div class="useful-websites-url">
            <a :href="site.link" target="_blank">
              {{ site.link }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div id="monument-content" v-if="view.content">
      <div
        class="monument-content-wrapper"
        v-for="(entry, index) in monument.relatedContent"
        :key="`related-entry-${index}`"
      >
        <div
          class="monument-description-header"
          @click="setIndexAndScroll($event, index)"
        >
          <div v-html="entry.details[language(entry.details)].name"></div>
          <div class="monument-source-project">
            In
            <span>{{
              entry.details[language(entry.details)].projectName
            }}</span>
            {{ entry.from[language(entry.from)].value }}
          </div>
        </div>
        <div class="description-wrapper" v-if="relatedIndex === index">
          <MonumentDescription
            :entry="entry"
            :language="defaultLanguage"
            :location="monument.locationName"
            :country="monument.countryName" 
            :glossary="monument.glossary"
          >
          </MonumentDescription>
        </div>
      </div>
    </div>

    <div id="monument-itineraries" v-if="view.itineraries">
      <div
        class="sub-itinerary-wrapper"
        v-for="sub in monument.relatedItineraries"
        :key="sub.subItineraryId"
      >
        <div class="sub-itinerary-parent">
          {{ returnValueInLanguage("en", sub.parentItineraryName).value }}
          ({{ sub.parentSubItineraryCount }} Sub-Itineraries)
        </div>
        <div class="sub-itinerary-panel">
          <div
            class="sub-itinerary-image"
            :style="{ backgroundImage: 'url(' + sub.itineraryImage + ')' }"
          ></div>
          <div class="sub-itinerary-info">
            <div class="sub-itinerary-link">
              <router-link
                :to="{
                  name: 'itineraries',
                  params: {
                    country: $route.params.country,
                    itinerary: `i-${sub.parentItineraryId}`,
                    subItinerary: `si-${sub.subItineraryId}`,
                  },
                }"
              >
                {{ sub.subItineraryOrderRoman }}.
                {{ returnValueInLanguage("en", sub.subItineraryName).value }}
                <span
                  v-if="
                    returnValueInLanguage('en', sub.subItineraryName).duration
                  "
                >
                  [{{
                    returnValueInLanguage("en", sub.subItineraryName).duration
                  }}]
                </span>
              </router-link>
            </div>
            <div
              class="sub-itinerary-description"
              v-if="
                sub.subItineraryDescription &&
                sub.subItineraryDescription.length > 0
              "
              v-html="
                truncate(
                  400,
                  returnValueInLanguage(
                    'en',
                    sub.subItineraryDescription[0].details
                  ).description
                )
              "
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MonumentField from "./MonumentField.vue";
import MonumentDescription from "./MonumentDescription.vue";
import language from "../mixins/language.js";
import truncate from "../mixins/truncate.js";
import media from "../mixins/media.js";
export default {
  name: "MonumentComponent",
  components: {
    MonumentField: MonumentField,
    MonumentDescription: MonumentDescription,
  },
  mixins: [language, truncate, media],
  props: ["monument"],
  watch: {
    monument() {
      this.showView(this.$route.params.tab);
      if (this.$route.params.tab !== "tab-content") {
        this.getLanguageList(
          this.monument.monumentDetails[0].details,
          "languagesList"
        );
        if (this.$route.params.language) {
          this.defaultLanguage = this.$route.params.language.substring(4);
        } else {
          this.setLanguage(this.languagesList, "defaultLanguage");
          if (!this.$route.params.language) {
            this.$router.replace({ params: { language: `lan-${this.defaultLanguage}` } });
          }
        }
      }
      this.getLanguageList(
        this.monument.locationContact,
        "locationLanguagesList"
      );
      this.setLanguage(this.locationLanguagesList, "locationLanguage");
      this.getLanguageList(
        this.monument.monumentDetails[0].furtherReadings,
        "furtherReadingsLanguagesList"
      );
      this.setLanguage(
        this.furtherReadingsLanguagesList,
        "furtherReadingsLanguage"
      );
    },
    defaultLanguage() {
      this.additionalInfoExists(this.monument.monumentDetails[0].details);
      if (this.$route.params.language) {
        if (this.defaultLanguage !== this.$route.params.language.substring(4)) { 
          this.$router.push({ params: { language: `lan-${this.defaultLanguage}` } });
        }
      }
    },
    furtherReadingsLanguage() {
      this.furtherReading = this.returnValueInLanguage(
        this.furtherReadingsLanguage,
        this.monument.monumentDetails[0].furtherReadings
      );
    },
  },
  data() {
    return {
      view: {
        description: false,
        map: false,
        directions: false,
        additional: false,
        content: false,
        itineraries: false,
      },

      defaultLanguage: this.$route.params.language ? this.$route.params.language.substring(4) : "",
      languagesList: [],
      descriptionIndex: 0,
      relatedIndex: 0,
      locationLanguage: "",
      locationLanguagesList: [],

      furtherReadingsLanguage: "",
      furtherReadingsLanguagesList: [],
      furtherReading: {},

      lessThan899: window.matchMedia("(max-width: 899px)").matches,
      showTabDropdowns: window.matchMedia("(max-width: 899px)").matches
        ? false
        : true,
    };
  },
  methods: {
    setIndexAndScroll: function (e, index) {
      this.relatedIndex = index;
      this.getLanguageList(
        this.monument.relatedContent[index].details,
        "languagesList"
      );
      this.setLanguage(this.languagesList, "defaultLanguage");
      this.$nextTick(() => {
        e.target.scrollIntoView({
          behavior: "smooth",
        });
      });
    },
    // Selecting a different tab changes the URL (router.push)
    changeView: function (e) {
      for (let category in this.view) {
        this.view[category] = false;
      }
      switch (e.target.id) {
        case "monument-menu-map":
          this.view.map = true;
          this.$router.push({ params: { tab: `tab-map` } });
          break;
        case "monument-menu-description":
          this.view.description = true;
          this.getLanguageList(
          this.monument.monumentDetails[0].details,
            "languagesList"
          );
          this.setLanguage(this.languagesList, "defaultLanguage");
          this.$router.push({ params: { tab: `tab-description` } });
          break;
        case "monument-menu-directions":
          this.view.directions = true;
          this.$router.push({ params: { tab: `tab-directions` } });
          break;
        case "monument-menu-additional":
          this.view.additional = true;
          this.$router.push({ params: { tab: `tab-additional` } });
          break;
        case "monument-menu-content":
          this.view.content = true;
          this.getLanguageList(
          this.monument.relatedContent[0].details,
            "languagesList"
          );
          this.setLanguage(this.languagesList, "defaultLanguage");
          this.$router.push({ params: { tab: `tab-content` } });
          break;
        case "monument-menu-itineraries":
          this.view.itineraries = true;
          this.$router.push({ params: { tab: `tab-itineraries` } });
          break;
      }
      if (this.lessThan899) {
        this.showTabDropdowns = !this.showTabDropdowns;
      }
    },
    language: function (array) {
      let english = false;
      let index = 0;
      let param = this.$route.params.language ? this.$route.params.language.substring(4) : "";
      for (let i = 0; i < array.length; i++) {
        if (param && 
          array[i].langId === param) {
          index = i;
          break;
        } else if (array[i].langId === "en") {
          english = true;
          index = i;
        }
      }
      if (param) {
        this.defaultLanguage = param;
        return index;
      } else if (english) {
        this.defaultLanguage = "en";
        return index;
      } else {
        this.defaultLanguage = array[index].langId;
        return 0;
      }
    },
    setLanguage: function (array, data) {
      let language = false;
      let english = false;
      // Check to see if current language is available
      for (let i = 0; i < array.length; i++) {
        // if (array[i] === this.defaultLanguage) {
        if (array[i] === this[data]) {
          language = true;
          break;
        }
      }
      // If language is true, no change required, exit
      if (language) {
        return;
        // If previously selected language is not available,
        // find English or first available language
      } else {
        for (let i = 0; i < array.length; i++) {
          // If English is available, set default
          if (array[i] === "en") {
            english = true;
            this[data] = "en";
            break;
          }
        }
        // Otherwise, set to first available language
        if (!english) {
          // this[data] = array[0].langId;
          this[data] = array[0];
        }
      }
    },
    hasInfo: function (property) {
      if (property && property.length > 0) {
        return true;
      } else {
        return false;
      }
    },
    getDirectionsInfoExists: function (details) {
      let info = this.returnValueInLanguage("en", details);
      if (
        this.hasInfo(info.getDirections) ||
        this.hasInfo(info.address) ||
        this.hasInfo(info.contact) ||
        this.hasInfo(info.tel) ||
        this.hasInfo(info.fax) ||
        this.hasInfo(info.email) ||
        this.hasInfo(info.website) ||
        this.hasInfo(info.responsibleInstitution.name)
      ) {
        return true;
      } else {
        return false;
      }
    },
     additionalInfoExists: function () {
      let monument = this.monument.monumentDetails[0];
      let info = this.returnValueInLanguage("en", monument.details);
      if (
        this.hasInfo(info.information) ||
        this.hasInfo(info.note) ||
        this.hasInfo(info.styles) ||
        this.hasInfo(info.bibliography) ||
        monument.furtherReadings.length > 0 ||
        this.monument.locationContact.length > 0 ||
        this.monument.accommodations.length > 0 ||
        this.monument.guidedVisits.length > 0 ||
        this.monument.usefulWebsites.length > 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    getLanguageList: function (array, data) {
      let languages = [];
      for (let i = 0; i < array.length; i++) {
        languages.push(array[i].langId);
      }
      this[data] = languages;
    },
    showView: function (param) {
      for (let category in this.view) {
        this.view[category] = false;
      }
      if (param) {
        switch (param.substring(4)) {
          case "description":
            this.view.description = true;
            break;
          case "map":
            this.view.map = true;
            break;
          case "directions":
            this.view.directions = true;
            break;
          case "additional":
            this.view.additional = true;
            break;
          case "content":
            this.view.content = true;
            break;
          case "itineraries":
            this.view.itineraries = true;
            break;
          default:
            break;
        }
      } else {
        this.view.description = true;
      }
    }
  },
  mounted() {
    this.showView(this.$route.params.tab);
  },
};
</script>

<style scoped lang="scss">
#monument-menu-container {
  position: relative;
  height: 55px;
  width: 100%;
  border-bottom: 2px solid $medium-light-grey;
  margin-top: 10px;
  margin-bottom: 20px;
}
#monument-menu {
  @include flex-center;
  position: absolute;
  top: 0;
  width: 100%;
}
.monument-menu-item {
  @include flex-center;
  @include headings;
  @include font-size-5;
  height: 50px;
  width: 150px;
  text-align: center;
  color: $medium-light-grey;
  padding-bottom: 12px;
  margin: 5px 10px 0 10px;
  border-bottom: 5px solid transparent;
  cursor: pointer;
}
.selected {
  color: $dark-green;
  border-bottom: 5px solid $dark-green;
}

#explore-map {
  height: 500px;
  width: 100%;
  margin-bottom: 40px;
}

.monument-description-header {
  @include headings;
  @include font-size-6;
}
.monument-source-project {
  font-weight: normal;
}
.monument-source-project span {
  font-style: italic;
}
#monument-content .monument-description-header {
  cursor: pointer;
}
.description-wrapper {
  margin-top: 20px;
}

.monument-language-selection {
  margin-bottom: 20px;
}

.further-readings-container {
  margin-bottom: 20px;
}
.further-readings-container * {
  @include texts;
  @include font-size-6;
}
.further-readings a {
  @include link-styles;
}
.further-readings a:hover {
  @include link-hover-styles;
}

.location-contact {
  @include texts;
  @include font-size-6;
  margin-bottom: 40px;
}
.location-contact .monument-field {
  margin-bottom: 0;
}

.monument-additional {
  margin-bottom: 40px;
}
.monument-additional * {
  @include texts;
  @include font-size-6;
}
.additional-label,
.additional-intro {
  margin-bottom: 20px;
}
.accommodations-hotel,
.guided-visits-contact,
.useful-websites-site {
  margin-bottom: 20px;
}
.hotel-category {
  font-style: italic;
}
.hotel-url a,
.useful-websites-url a {
  @include link-styles;
}

.monument-content-wrapper {
  box-shadow: 0px 2px 8px $light-grey;
  padding: 15px 10px;
}

.sub-itinerary-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.sub-itinerary-parent {
  @include headings;
  @include font-size-5;
  margin-bottom: 10px;
}
.sub-itinerary-panel {
  display: flex;
  height: 200px;
  width: 100%;
  box-shadow: 0px 2px 8px $light-grey;
  margin-bottom: 20px;
}
.sub-itinerary-image {
  height: 200px;
  width: 300px;
  background-color: $dark-green;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.sub-itinerary-info {
  width: 100%;
  padding: 20px 30px;
}

.sub-itinerary-link a {
  @include headings;
  @include font-size-5;
  color: $dark-green;
}
.sub-itinerary-description {
  margin-top: 20px;
}
.sub-itinerary-description,
.sub-itinerary-description :deep(*) {
  @include texts;
  @include font-size-6;
}
.sub-itinerary-description :deep(br) {
  content: " ";
}
.sub-itinerary-description :deep(br:after) {
  content: " ";
}

@media only screen and (max-width: 899px) {
  #monument-menu-container {
    height: auto;
    border-bottom: none;
  }
  #monument-menu {
    flex-direction: column;
    position: relative;
  }
  .monument-menu-item {
    width: 100%;
    border-bottom: 5px solid $light-grey;
  }
  .selected {
    color: $dark-green;
    border-bottom: 5px solid $dark-green;
  }
  .monument-menu-arrow {
    font-size: 75%;
    margin-left: 10px;
  }
  .sub-itinerary-panel {
    height: 300px;
    width: 100%;
  }
  .sub-itinerary-image {
    height: 300px;
    width: 400px;
  }
}

@media only screen and (max-width: 699px) {
  .sub-itinerary-panel {
    flex-direction: column;
    height: auto;
    width: 100%;
  }
  .sub-itinerary-image {
    height: 200px;
    width: 100%;
  }
}

@media only screen and (max-width: 499px) {
  #sub-itinerary-label {
    @include font-size-4;
  }
  .sub-itinerary-info {
    padding: 15px;
  }
}
</style>
